// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Z-nT","left":"styles_left__2Cyfu","desktopActions":"styles_desktopActions__2ZDck","title":"styles_title__2ZaeH"};